import { useEffect } from 'react';
import { Amplify } from 'aws-amplify';

interface UseConfigOptions {
  amplifyConfig: any;
  onConfigured?: () => void;
}

export const useConfig = ({ amplifyConfig, onConfigured }: UseConfigOptions) => {
  useEffect(() => {
    // Configure Amplify with dynamic redirect URLs
    const config = {
      ...amplifyConfig,
      oauth: {
        ...amplifyConfig.oauth,
        redirectSignIn: `${window.location.origin}/`,
        redirectSignOut: `${window.location.origin}/`,
      },
    };

    Amplify.configure(config);

    if (onConfigured) {
      onConfigured();
    }
  }, [amplifyConfig, onConfigured]);

  const getRedirectUrls = () => ({
    signIn: `${window.location.origin}/`,
    signOut: `${window.location.origin}/`,
  });

  return {
    getRedirectUrls,
  };
};